import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "../styles/NextSection.css";

const NextSection = () => {
  const navigate = useNavigate();
  const [showAuthModal, setShowAuthModal] = useState(false);

  const handlePickTemplate = () => {
    const token = localStorage.getItem("token");
    if (token) {
      navigate("/create"); // ✅ logged in
    } else {
      setShowAuthModal(true); // 🔥 show modal
    }
  };

  return (
    <section className="next-section">
      <img src="/wave.jpg" alt="Wave Background" className="wave-background" />

      <div className="text-frame">
        <h2 className="next-section-heading">From you to Them in Seconds</h2>
        <p className="next-section-subtext">
          Accelerating your productivity with our technology. <br />
          Reduce downtime and optimize costs.
        </p>

        <div className="arrow-button-frame">
          <div className="arrow-frame">
            <img
              src="/arrow-icon.svg"
              alt="Arrow Icon"
              className="next-section-arrow"
            />
          </div>
          {/* ✅ Pick Template Button */}
          <button
            className="pick-template-button-a"
            onClick={handlePickTemplate}
          >
            Pick Template
          </button>
        </div>
      </div>

      {/* ✅ Auth Modal */}
      {showAuthModal && (
        <div className="auth-modal-overlay">
          <div className="auth-modal">
            <h3>Login Required</h3>
            <p>
              Hey there! You’ll need to sign in or create an account before you
              can pick a template.
            </p>
            <div className="auth-modal-buttons">
              <button onClick={() => navigate("/login")}>Login</button>
              <button onClick={() => navigate("/signup")}>Sign Up</button>
              <button
                onClick={() => setShowAuthModal(false)}
                className="cancel-btn"
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

export default NextSection;
